import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'
import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import LayoutContainer from 'components/Common/LayoutContainer'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import LoyaltyProductLogo from '../LoyaltyProductLogo'

const Container = styled.div`
  padding-block: ${rem(12)};

  &.tier-bronze {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.bronze.normalBackground}, ${props => props.theme.palette.product.loyalty.bronze.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }
  &.tier-silver {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.silver.normalBackground}, ${props => props.theme.palette.product.loyalty.silver.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }
  &.tier-gold {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.gold.normalBackground}, ${props => props.theme.palette.product.loyalty.gold.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }
  &.tier-platinum {
    background: linear-gradient(to right, ${props => props.theme.palette.product.loyalty.platinum.normalBackground}, ${props => props.theme.palette.product.loyalty.platinum.lightBackground});
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

function LoyaltyMembershipActivationPageBanner() {
  const [accountEligibleTier, accountEligibleTierLoading, accountEligibleTierError] = useLoyaltyUserEligibilityTier()
  const givenName = useAppSelector(state => state.auth.account.givenName)

  const dispatch = useAppDispatch()
  const activateMembership = useCallback(() => {
    dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
  }, [dispatch])

  if (!accountEligibleTier || accountEligibleTierLoading || accountEligibleTierError || accountEligibleTier === 'platinum') return null
  const tierName = getLoyaltyTierDisplayName(accountEligibleTier)

  return <Container className={`tier-${accountEligibleTier}`}>
    <LayoutContainer>
      <Group direction="vertical" tabletDirection="horizontal" tabletHorizontalAlign="center" gap="8 20" verticalAlign="center" wrap="wrap">
        <Group direction="horizontal" gap={12} verticalAlign="center">
          <LoyaltyProductLogo height={24} />
          <LoyaltyTierLabel kind="primary" tier={accountEligibleTier} format="uppercase">Exclusive Invite</LoyaltyTierLabel>
        </Group>
        <BodyText variant="medium">
          {!!givenName && <>{givenName}, you've unlocked</>}
          {!givenName && <>You've unlocked</>}
          {' '}
          <Colour value={`tier-${accountEligibleTier}-light-contrast`} as="b">
            {tierName} status
          </Colour>
          {' '}
          in our new rewards program.
          {' '}
          <TextLink size="medium" onClick={activateMembership}>Activate for free</TextLink>
        </BodyText>
      </Group>
    </LayoutContainer>
  </Container>
}

export default LoyaltyMembershipActivationPageBanner
